const questionsColors = {
    1:"indian-red",
    2:"light-sky",
    3:"violet-red",
    4:"fire-brick",
    5:"crimson-green",
    6: "medium-purple",
    7:"medium-blue",
    8:"dark-turquoise",
    9:"dark-see",
    10:"light-brown"
  }
    
  export default questionsColors;